export default "__VITE_ASSET__CnHnbJuy__"